import { generatePath } from 'react-router-dom';
import { User, UserRoleName } from '../@types/user';
import { API_ROUTES } from '../consts';
import request from './index';

export type InviteUserToAccountRequest = {
  accountId: string;
  email: string;
  userRoleName: UserRoleName;
};

export const inviteUserToAccount = async ({
  accountId,
  email,
  userRoleName,
}: InviteUserToAccountRequest): Promise<void> => {
  const { data } = await request.post(
    generatePath(API_ROUTES.INVITE_USER, { accountId }),
    { email, userRoleName },
  );

  return data;
};

export const getUserById = async (userId: string): Promise<User> => {
  const { data } = await request.get(
    generatePath(API_ROUTES.USER_BY_ID, { userId }),
  );

  return data;
};

export type useUserActivationLinkResponse = {
  link: string;
};

export const getUserActivationLink = async (userId: string): Promise<useUserActivationLinkResponse> => {
  const { data } = await request.get(
    generatePath(API_ROUTES.USER_ACTIVATION_LINK, { userId }),
  );

  return data;
};

export const getAccountUsers = async (accountId: string): Promise<User[]> => {
  const { data } = await request.get(
    generatePath(API_ROUTES.ACCOUNT_USERS, { accountId }),
  );

  return data;
};
